"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var ProductLink_1 = __importDefault(require("./ProductLink"));
/**
 * 右侧tab内容
 * @param props
 * @constructor
 */
var RightSide = function (props) {
    var data = props.data, activeTab = props.activeTab;
    return (react_1.default.createElement("div", { className: "right-side-layout" }, data.map(function (item, index) {
        var headline = item.headline, title = item.title, img = item.img, contentDescribe = item.contentDescribe, list = item.list;
        var productTitle = (list || {}).title;
        return (react_1.default.createElement("section", { key: index, className: (0, classnames_1.default)('content', {
                active: activeTab === index,
            }) },
            headline && react_1.default.createElement("span", { className: "headline" }, headline),
            img && react_1.default.createElement("img", { key: index, src: img, className: "image", alt: "".concat(item.title) }),
            title && react_1.default.createElement("span", { className: "title" }, title),
            contentDescribe && react_1.default.createElement("article", { dangerouslySetInnerHTML: { __html: contentDescribe } }),
            productTitle && react_1.default.createElement(ProductLink_1.default, { list: list })));
    })));
};
exports.default = RightSide;
//# sourceMappingURL=RightSide.js.map